import { TipoServicoLote } from "../types/loteAgendamento";

export const SERVICO_POR_TIPO_SERVICO: Record<TipoServicoLote, string> = {
  transferencia: "Transferência",
  "primeiro-emplacamento": "Primeiro Emplacamento",
};
